/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CustomToolCreateDTO } from '../models';
// @ts-ignore
import type { CustomToolResponseDTO } from '../models';
// @ts-ignore
import type { CustomToolUpdateDTO } from '../models';
// @ts-ignore
import type { DynamicParameterCreateDTO } from '../models';
// @ts-ignore
import type { DynamicParameterResponseDTO } from '../models';
// @ts-ignore
import type { DynamicParameterUpdateDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageCustomToolResponseDTO } from '../models';
// @ts-ignore
import type { StaticValueCreateDTO } from '../models';
// @ts-ignore
import type { StaticValueResponseDTO } from '../models';
// @ts-ignore
import type { StaticValueUpdateDTO } from '../models';
// @ts-ignore
import type { TestExecutionRequestDTO } from '../models';
// @ts-ignore
import type { TestExecutionResponseDTO } from '../models';
/**
 * CustomToolsApi - axios parameter creator
 * @export
 */
export const CustomToolsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new custom tool in the current organization.  Requires \'custom_tool:write\' permission.
         * @summary Create Custom Tool
         * @param {CustomToolCreateDTO} customToolCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomToolApiV1CustomToolsPost: async (customToolCreateDTO: CustomToolCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customToolCreateDTO' is not null or undefined
            assertParamExists('createCustomToolApiV1CustomToolsPost', 'customToolCreateDTO', customToolCreateDTO)
            const localVarPath = `/api/v1/custom-tools/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customToolCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new custom tool in the current organization.  Requires \'custom_tool:write\' permission.
         * @summary Create Custom Tool
         * @param {CustomToolCreateDTO} customToolCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomToolApiV1CustomToolsPost_1: async (customToolCreateDTO: CustomToolCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customToolCreateDTO' is not null or undefined
            assertParamExists('createCustomToolApiV1CustomToolsPost_1', 'customToolCreateDTO', customToolCreateDTO)
            const localVarPath = `/api/v1/custom-tools/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customToolCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new dynamic parameter for a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Create Dynamic Parameter
         * @param {string} toolId 
         * @param {DynamicParameterCreateDTO} dynamicParameterCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost: async (toolId: string, dynamicParameterCreateDTO: DynamicParameterCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost', 'toolId', toolId)
            // verify required parameter 'dynamicParameterCreateDTO' is not null or undefined
            assertParamExists('createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost', 'dynamicParameterCreateDTO', dynamicParameterCreateDTO)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/dynamic-parameters`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dynamicParameterCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new dynamic parameter for a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Create Dynamic Parameter
         * @param {string} toolId 
         * @param {DynamicParameterCreateDTO} dynamicParameterCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost_2: async (toolId: string, dynamicParameterCreateDTO: DynamicParameterCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost_2', 'toolId', toolId)
            // verify required parameter 'dynamicParameterCreateDTO' is not null or undefined
            assertParamExists('createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost_2', 'dynamicParameterCreateDTO', dynamicParameterCreateDTO)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/dynamic-parameters`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dynamicParameterCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new static value for a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Create Static Value
         * @param {string} toolId 
         * @param {StaticValueCreateDTO} staticValueCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaticValueApiV1CustomToolsToolIdStaticValuesPost: async (toolId: string, staticValueCreateDTO: StaticValueCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('createStaticValueApiV1CustomToolsToolIdStaticValuesPost', 'toolId', toolId)
            // verify required parameter 'staticValueCreateDTO' is not null or undefined
            assertParamExists('createStaticValueApiV1CustomToolsToolIdStaticValuesPost', 'staticValueCreateDTO', staticValueCreateDTO)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/static-values`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(staticValueCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new static value for a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Create Static Value
         * @param {string} toolId 
         * @param {StaticValueCreateDTO} staticValueCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaticValueApiV1CustomToolsToolIdStaticValuesPost_3: async (toolId: string, staticValueCreateDTO: StaticValueCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('createStaticValueApiV1CustomToolsToolIdStaticValuesPost_3', 'toolId', toolId)
            // verify required parameter 'staticValueCreateDTO' is not null or undefined
            assertParamExists('createStaticValueApiV1CustomToolsToolIdStaticValuesPost_3', 'staticValueCreateDTO', staticValueCreateDTO)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/static-values`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(staticValueCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a custom tool and all its static values and dynamic parameters.  Requires \'custom_tool:write\' permission.
         * @summary Delete Custom Tool
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomToolApiV1CustomToolsToolIdDelete: async (toolId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('deleteCustomToolApiV1CustomToolsToolIdDelete', 'toolId', toolId)
            const localVarPath = `/api/v1/custom-tools/{tool_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a custom tool and all its static values and dynamic parameters.  Requires \'custom_tool:write\' permission.
         * @summary Delete Custom Tool
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomToolApiV1CustomToolsToolIdDelete_4: async (toolId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('deleteCustomToolApiV1CustomToolsToolIdDelete_4', 'toolId', toolId)
            const localVarPath = `/api/v1/custom-tools/{tool_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a dynamic parameter from a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Delete Dynamic Parameter
         * @param {string} toolId 
         * @param {string} paramId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete: async (toolId: string, paramId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete', 'toolId', toolId)
            // verify required parameter 'paramId' is not null or undefined
            assertParamExists('deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete', 'paramId', paramId)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/dynamic-parameters/{param_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)))
                .replace(`{${"param_id"}}`, encodeURIComponent(String(paramId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a dynamic parameter from a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Delete Dynamic Parameter
         * @param {string} toolId 
         * @param {string} paramId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete_5: async (toolId: string, paramId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete_5', 'toolId', toolId)
            // verify required parameter 'paramId' is not null or undefined
            assertParamExists('deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete_5', 'paramId', paramId)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/dynamic-parameters/{param_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)))
                .replace(`{${"param_id"}}`, encodeURIComponent(String(paramId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a static value from a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Delete Static Value
         * @param {string} toolId 
         * @param {string} valueId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete: async (toolId: string, valueId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete', 'toolId', toolId)
            // verify required parameter 'valueId' is not null or undefined
            assertParamExists('deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete', 'valueId', valueId)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/static-values/{value_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)))
                .replace(`{${"value_id"}}`, encodeURIComponent(String(valueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a static value from a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Delete Static Value
         * @param {string} toolId 
         * @param {string} valueId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete_6: async (toolId: string, valueId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete_6', 'toolId', toolId)
            // verify required parameter 'valueId' is not null or undefined
            assertParamExists('deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete_6', 'valueId', valueId)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/static-values/{value_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)))
                .replace(`{${"value_id"}}`, encodeURIComponent(String(valueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific custom tool by ID.  Requires \'custom_tool:view\' permission.
         * @summary Get Custom Tool
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomToolApiV1CustomToolsToolIdGet: async (toolId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('getCustomToolApiV1CustomToolsToolIdGet', 'toolId', toolId)
            const localVarPath = `/api/v1/custom-tools/{tool_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific custom tool by ID.  Requires \'custom_tool:view\' permission.
         * @summary Get Custom Tool
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomToolApiV1CustomToolsToolIdGet_7: async (toolId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('getCustomToolApiV1CustomToolsToolIdGet_7', 'toolId', toolId)
            const localVarPath = `/api/v1/custom-tools/{tool_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all custom tools in the current user\'s organization.  Requires \'custom_tool:view\' permission.
         * @summary List Custom Tools
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomToolsApiV1CustomToolsGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/custom-tools/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all custom tools in the current user\'s organization.  Requires \'custom_tool:view\' permission.
         * @summary List Custom Tools
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomToolsApiV1CustomToolsGet_8: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/custom-tools/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all dynamic parameters for a custom tool.  Requires \'custom_tool:view\' permission.
         * @summary List Dynamic Parameters
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet: async (toolId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet', 'toolId', toolId)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/dynamic-parameters`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all dynamic parameters for a custom tool.  Requires \'custom_tool:view\' permission.
         * @summary List Dynamic Parameters
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet_9: async (toolId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet_9', 'toolId', toolId)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/dynamic-parameters`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all static values for a custom tool.  Requires \'custom_tool:view\' permission.
         * @summary List Static Values
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStaticValuesApiV1CustomToolsToolIdStaticValuesGet: async (toolId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('listStaticValuesApiV1CustomToolsToolIdStaticValuesGet', 'toolId', toolId)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/static-values`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all static values for a custom tool.  Requires \'custom_tool:view\' permission.
         * @summary List Static Values
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStaticValuesApiV1CustomToolsToolIdStaticValuesGet_10: async (toolId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('listStaticValuesApiV1CustomToolsToolIdStaticValuesGet_10', 'toolId', toolId)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/static-values`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test execute a custom tool with provided dynamic parameters.  This endpoint allows testing a custom tool\'s HTTP request configuration before using it in agent conversations. It performs the full execution flow including: - Validating dynamic parameters - Checking rate limits - Interpolating variables - Making the HTTP request  Requires \'custom_tool:write\' permission.
         * @summary Test Custom Tool
         * @param {string} toolId 
         * @param {TestExecutionRequestDTO} testExecutionRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCustomToolApiV1CustomToolsToolIdTestPost: async (toolId: string, testExecutionRequestDTO: TestExecutionRequestDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('testCustomToolApiV1CustomToolsToolIdTestPost', 'toolId', toolId)
            // verify required parameter 'testExecutionRequestDTO' is not null or undefined
            assertParamExists('testCustomToolApiV1CustomToolsToolIdTestPost', 'testExecutionRequestDTO', testExecutionRequestDTO)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/test`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testExecutionRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test execute a custom tool with provided dynamic parameters.  This endpoint allows testing a custom tool\'s HTTP request configuration before using it in agent conversations. It performs the full execution flow including: - Validating dynamic parameters - Checking rate limits - Interpolating variables - Making the HTTP request  Requires \'custom_tool:write\' permission.
         * @summary Test Custom Tool
         * @param {string} toolId 
         * @param {TestExecutionRequestDTO} testExecutionRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCustomToolApiV1CustomToolsToolIdTestPost_11: async (toolId: string, testExecutionRequestDTO: TestExecutionRequestDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('testCustomToolApiV1CustomToolsToolIdTestPost_11', 'toolId', toolId)
            // verify required parameter 'testExecutionRequestDTO' is not null or undefined
            assertParamExists('testCustomToolApiV1CustomToolsToolIdTestPost_11', 'testExecutionRequestDTO', testExecutionRequestDTO)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/test`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testExecutionRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a custom tool\'s configuration.  Requires \'custom_tool:write\' permission.
         * @summary Update Custom Tool
         * @param {string} toolId 
         * @param {CustomToolUpdateDTO} customToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomToolApiV1CustomToolsToolIdPatch: async (toolId: string, customToolUpdateDTO: CustomToolUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('updateCustomToolApiV1CustomToolsToolIdPatch', 'toolId', toolId)
            // verify required parameter 'customToolUpdateDTO' is not null or undefined
            assertParamExists('updateCustomToolApiV1CustomToolsToolIdPatch', 'customToolUpdateDTO', customToolUpdateDTO)
            const localVarPath = `/api/v1/custom-tools/{tool_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customToolUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a custom tool\'s configuration.  Requires \'custom_tool:write\' permission.
         * @summary Update Custom Tool
         * @param {string} toolId 
         * @param {CustomToolUpdateDTO} customToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomToolApiV1CustomToolsToolIdPatch_12: async (toolId: string, customToolUpdateDTO: CustomToolUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('updateCustomToolApiV1CustomToolsToolIdPatch_12', 'toolId', toolId)
            // verify required parameter 'customToolUpdateDTO' is not null or undefined
            assertParamExists('updateCustomToolApiV1CustomToolsToolIdPatch_12', 'customToolUpdateDTO', customToolUpdateDTO)
            const localVarPath = `/api/v1/custom-tools/{tool_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customToolUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a dynamic parameter.  Requires \'custom_tool:write\' permission.
         * @summary Update Dynamic Parameter
         * @param {string} toolId 
         * @param {string} paramId 
         * @param {DynamicParameterUpdateDTO} dynamicParameterUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch: async (toolId: string, paramId: string, dynamicParameterUpdateDTO: DynamicParameterUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch', 'toolId', toolId)
            // verify required parameter 'paramId' is not null or undefined
            assertParamExists('updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch', 'paramId', paramId)
            // verify required parameter 'dynamicParameterUpdateDTO' is not null or undefined
            assertParamExists('updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch', 'dynamicParameterUpdateDTO', dynamicParameterUpdateDTO)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/dynamic-parameters/{param_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)))
                .replace(`{${"param_id"}}`, encodeURIComponent(String(paramId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dynamicParameterUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a dynamic parameter.  Requires \'custom_tool:write\' permission.
         * @summary Update Dynamic Parameter
         * @param {string} toolId 
         * @param {string} paramId 
         * @param {DynamicParameterUpdateDTO} dynamicParameterUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch_13: async (toolId: string, paramId: string, dynamicParameterUpdateDTO: DynamicParameterUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch_13', 'toolId', toolId)
            // verify required parameter 'paramId' is not null or undefined
            assertParamExists('updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch_13', 'paramId', paramId)
            // verify required parameter 'dynamicParameterUpdateDTO' is not null or undefined
            assertParamExists('updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch_13', 'dynamicParameterUpdateDTO', dynamicParameterUpdateDTO)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/dynamic-parameters/{param_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)))
                .replace(`{${"param_id"}}`, encodeURIComponent(String(paramId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dynamicParameterUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a static value.  Requires \'custom_tool:write\' permission.
         * @summary Update Static Value
         * @param {string} toolId 
         * @param {string} valueId 
         * @param {StaticValueUpdateDTO} staticValueUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch: async (toolId: string, valueId: string, staticValueUpdateDTO: StaticValueUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch', 'toolId', toolId)
            // verify required parameter 'valueId' is not null or undefined
            assertParamExists('updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch', 'valueId', valueId)
            // verify required parameter 'staticValueUpdateDTO' is not null or undefined
            assertParamExists('updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch', 'staticValueUpdateDTO', staticValueUpdateDTO)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/static-values/{value_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)))
                .replace(`{${"value_id"}}`, encodeURIComponent(String(valueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(staticValueUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a static value.  Requires \'custom_tool:write\' permission.
         * @summary Update Static Value
         * @param {string} toolId 
         * @param {string} valueId 
         * @param {StaticValueUpdateDTO} staticValueUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch_14: async (toolId: string, valueId: string, staticValueUpdateDTO: StaticValueUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch_14', 'toolId', toolId)
            // verify required parameter 'valueId' is not null or undefined
            assertParamExists('updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch_14', 'valueId', valueId)
            // verify required parameter 'staticValueUpdateDTO' is not null or undefined
            assertParamExists('updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch_14', 'staticValueUpdateDTO', staticValueUpdateDTO)
            const localVarPath = `/api/v1/custom-tools/{tool_id}/static-values/{value_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)))
                .replace(`{${"value_id"}}`, encodeURIComponent(String(valueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(staticValueUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomToolsApi - functional programming interface
 * @export
 */
export const CustomToolsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomToolsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new custom tool in the current organization.  Requires \'custom_tool:write\' permission.
         * @summary Create Custom Tool
         * @param {CustomToolCreateDTO} customToolCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomToolApiV1CustomToolsPost(customToolCreateDTO: CustomToolCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomToolResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomToolApiV1CustomToolsPost(customToolCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.createCustomToolApiV1CustomToolsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new custom tool in the current organization.  Requires \'custom_tool:write\' permission.
         * @summary Create Custom Tool
         * @param {CustomToolCreateDTO} customToolCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomToolApiV1CustomToolsPost_1(customToolCreateDTO: CustomToolCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomToolResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomToolApiV1CustomToolsPost_1(customToolCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.createCustomToolApiV1CustomToolsPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new dynamic parameter for a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Create Dynamic Parameter
         * @param {string} toolId 
         * @param {DynamicParameterCreateDTO} dynamicParameterCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost(toolId: string, dynamicParameterCreateDTO: DynamicParameterCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DynamicParameterResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost(toolId, dynamicParameterCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new dynamic parameter for a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Create Dynamic Parameter
         * @param {string} toolId 
         * @param {DynamicParameterCreateDTO} dynamicParameterCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost_2(toolId: string, dynamicParameterCreateDTO: DynamicParameterCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DynamicParameterResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost_2(toolId, dynamicParameterCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new static value for a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Create Static Value
         * @param {string} toolId 
         * @param {StaticValueCreateDTO} staticValueCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStaticValueApiV1CustomToolsToolIdStaticValuesPost(toolId: string, staticValueCreateDTO: StaticValueCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaticValueResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStaticValueApiV1CustomToolsToolIdStaticValuesPost(toolId, staticValueCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.createStaticValueApiV1CustomToolsToolIdStaticValuesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new static value for a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Create Static Value
         * @param {string} toolId 
         * @param {StaticValueCreateDTO} staticValueCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStaticValueApiV1CustomToolsToolIdStaticValuesPost_3(toolId: string, staticValueCreateDTO: StaticValueCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaticValueResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStaticValueApiV1CustomToolsToolIdStaticValuesPost_3(toolId, staticValueCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.createStaticValueApiV1CustomToolsToolIdStaticValuesPost_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a custom tool and all its static values and dynamic parameters.  Requires \'custom_tool:write\' permission.
         * @summary Delete Custom Tool
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomToolApiV1CustomToolsToolIdDelete(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomToolApiV1CustomToolsToolIdDelete(toolId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.deleteCustomToolApiV1CustomToolsToolIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a custom tool and all its static values and dynamic parameters.  Requires \'custom_tool:write\' permission.
         * @summary Delete Custom Tool
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomToolApiV1CustomToolsToolIdDelete_4(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomToolApiV1CustomToolsToolIdDelete_4(toolId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.deleteCustomToolApiV1CustomToolsToolIdDelete_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a dynamic parameter from a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Delete Dynamic Parameter
         * @param {string} toolId 
         * @param {string} paramId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete(toolId: string, paramId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete(toolId, paramId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a dynamic parameter from a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Delete Dynamic Parameter
         * @param {string} toolId 
         * @param {string} paramId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete_5(toolId: string, paramId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete_5(toolId, paramId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a static value from a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Delete Static Value
         * @param {string} toolId 
         * @param {string} valueId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete(toolId: string, valueId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete(toolId, valueId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a static value from a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Delete Static Value
         * @param {string} toolId 
         * @param {string} valueId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete_6(toolId: string, valueId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete_6(toolId, valueId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific custom tool by ID.  Requires \'custom_tool:view\' permission.
         * @summary Get Custom Tool
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomToolApiV1CustomToolsToolIdGet(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomToolResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomToolApiV1CustomToolsToolIdGet(toolId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.getCustomToolApiV1CustomToolsToolIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific custom tool by ID.  Requires \'custom_tool:view\' permission.
         * @summary Get Custom Tool
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomToolApiV1CustomToolsToolIdGet_7(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomToolResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomToolApiV1CustomToolsToolIdGet_7(toolId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.getCustomToolApiV1CustomToolsToolIdGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all custom tools in the current user\'s organization.  Requires \'custom_tool:view\' permission.
         * @summary List Custom Tools
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCustomToolsApiV1CustomToolsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCustomToolResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCustomToolsApiV1CustomToolsGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.listCustomToolsApiV1CustomToolsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all custom tools in the current user\'s organization.  Requires \'custom_tool:view\' permission.
         * @summary List Custom Tools
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCustomToolsApiV1CustomToolsGet_8(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCustomToolResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCustomToolsApiV1CustomToolsGet_8(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.listCustomToolsApiV1CustomToolsGet_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all dynamic parameters for a custom tool.  Requires \'custom_tool:view\' permission.
         * @summary List Dynamic Parameters
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DynamicParameterResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet(toolId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all dynamic parameters for a custom tool.  Requires \'custom_tool:view\' permission.
         * @summary List Dynamic Parameters
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet_9(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DynamicParameterResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet_9(toolId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet_9']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all static values for a custom tool.  Requires \'custom_tool:view\' permission.
         * @summary List Static Values
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStaticValuesApiV1CustomToolsToolIdStaticValuesGet(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StaticValueResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStaticValuesApiV1CustomToolsToolIdStaticValuesGet(toolId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.listStaticValuesApiV1CustomToolsToolIdStaticValuesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all static values for a custom tool.  Requires \'custom_tool:view\' permission.
         * @summary List Static Values
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStaticValuesApiV1CustomToolsToolIdStaticValuesGet_10(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StaticValueResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStaticValuesApiV1CustomToolsToolIdStaticValuesGet_10(toolId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.listStaticValuesApiV1CustomToolsToolIdStaticValuesGet_10']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test execute a custom tool with provided dynamic parameters.  This endpoint allows testing a custom tool\'s HTTP request configuration before using it in agent conversations. It performs the full execution flow including: - Validating dynamic parameters - Checking rate limits - Interpolating variables - Making the HTTP request  Requires \'custom_tool:write\' permission.
         * @summary Test Custom Tool
         * @param {string} toolId 
         * @param {TestExecutionRequestDTO} testExecutionRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testCustomToolApiV1CustomToolsToolIdTestPost(toolId: string, testExecutionRequestDTO: TestExecutionRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestExecutionResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testCustomToolApiV1CustomToolsToolIdTestPost(toolId, testExecutionRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.testCustomToolApiV1CustomToolsToolIdTestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test execute a custom tool with provided dynamic parameters.  This endpoint allows testing a custom tool\'s HTTP request configuration before using it in agent conversations. It performs the full execution flow including: - Validating dynamic parameters - Checking rate limits - Interpolating variables - Making the HTTP request  Requires \'custom_tool:write\' permission.
         * @summary Test Custom Tool
         * @param {string} toolId 
         * @param {TestExecutionRequestDTO} testExecutionRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testCustomToolApiV1CustomToolsToolIdTestPost_11(toolId: string, testExecutionRequestDTO: TestExecutionRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestExecutionResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testCustomToolApiV1CustomToolsToolIdTestPost_11(toolId, testExecutionRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.testCustomToolApiV1CustomToolsToolIdTestPost_11']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a custom tool\'s configuration.  Requires \'custom_tool:write\' permission.
         * @summary Update Custom Tool
         * @param {string} toolId 
         * @param {CustomToolUpdateDTO} customToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomToolApiV1CustomToolsToolIdPatch(toolId: string, customToolUpdateDTO: CustomToolUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomToolResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomToolApiV1CustomToolsToolIdPatch(toolId, customToolUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.updateCustomToolApiV1CustomToolsToolIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a custom tool\'s configuration.  Requires \'custom_tool:write\' permission.
         * @summary Update Custom Tool
         * @param {string} toolId 
         * @param {CustomToolUpdateDTO} customToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomToolApiV1CustomToolsToolIdPatch_12(toolId: string, customToolUpdateDTO: CustomToolUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomToolResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomToolApiV1CustomToolsToolIdPatch_12(toolId, customToolUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.updateCustomToolApiV1CustomToolsToolIdPatch_12']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a dynamic parameter.  Requires \'custom_tool:write\' permission.
         * @summary Update Dynamic Parameter
         * @param {string} toolId 
         * @param {string} paramId 
         * @param {DynamicParameterUpdateDTO} dynamicParameterUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch(toolId: string, paramId: string, dynamicParameterUpdateDTO: DynamicParameterUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DynamicParameterResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch(toolId, paramId, dynamicParameterUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a dynamic parameter.  Requires \'custom_tool:write\' permission.
         * @summary Update Dynamic Parameter
         * @param {string} toolId 
         * @param {string} paramId 
         * @param {DynamicParameterUpdateDTO} dynamicParameterUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch_13(toolId: string, paramId: string, dynamicParameterUpdateDTO: DynamicParameterUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DynamicParameterResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch_13(toolId, paramId, dynamicParameterUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch_13']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a static value.  Requires \'custom_tool:write\' permission.
         * @summary Update Static Value
         * @param {string} toolId 
         * @param {string} valueId 
         * @param {StaticValueUpdateDTO} staticValueUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch(toolId: string, valueId: string, staticValueUpdateDTO: StaticValueUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaticValueResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch(toolId, valueId, staticValueUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a static value.  Requires \'custom_tool:write\' permission.
         * @summary Update Static Value
         * @param {string} toolId 
         * @param {string} valueId 
         * @param {StaticValueUpdateDTO} staticValueUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch_14(toolId: string, valueId: string, staticValueUpdateDTO: StaticValueUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaticValueResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch_14(toolId, valueId, staticValueUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch_14']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomToolsApi - factory interface
 * @export
 */
export const CustomToolsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomToolsApiFp(configuration)
    return {
        /**
         * Create a new custom tool in the current organization.  Requires \'custom_tool:write\' permission.
         * @summary Create Custom Tool
         * @param {CustomToolCreateDTO} customToolCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomToolApiV1CustomToolsPost(customToolCreateDTO: CustomToolCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CustomToolResponseDTO> {
            return localVarFp.createCustomToolApiV1CustomToolsPost(customToolCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new custom tool in the current organization.  Requires \'custom_tool:write\' permission.
         * @summary Create Custom Tool
         * @param {CustomToolCreateDTO} customToolCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomToolApiV1CustomToolsPost_1(customToolCreateDTO: CustomToolCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CustomToolResponseDTO> {
            return localVarFp.createCustomToolApiV1CustomToolsPost_1(customToolCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new dynamic parameter for a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Create Dynamic Parameter
         * @param {string} toolId 
         * @param {DynamicParameterCreateDTO} dynamicParameterCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost(toolId: string, dynamicParameterCreateDTO: DynamicParameterCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<DynamicParameterResponseDTO> {
            return localVarFp.createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost(toolId, dynamicParameterCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new dynamic parameter for a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Create Dynamic Parameter
         * @param {string} toolId 
         * @param {DynamicParameterCreateDTO} dynamicParameterCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost_2(toolId: string, dynamicParameterCreateDTO: DynamicParameterCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<DynamicParameterResponseDTO> {
            return localVarFp.createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost_2(toolId, dynamicParameterCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new static value for a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Create Static Value
         * @param {string} toolId 
         * @param {StaticValueCreateDTO} staticValueCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaticValueApiV1CustomToolsToolIdStaticValuesPost(toolId: string, staticValueCreateDTO: StaticValueCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<StaticValueResponseDTO> {
            return localVarFp.createStaticValueApiV1CustomToolsToolIdStaticValuesPost(toolId, staticValueCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new static value for a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Create Static Value
         * @param {string} toolId 
         * @param {StaticValueCreateDTO} staticValueCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaticValueApiV1CustomToolsToolIdStaticValuesPost_3(toolId: string, staticValueCreateDTO: StaticValueCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<StaticValueResponseDTO> {
            return localVarFp.createStaticValueApiV1CustomToolsToolIdStaticValuesPost_3(toolId, staticValueCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a custom tool and all its static values and dynamic parameters.  Requires \'custom_tool:write\' permission.
         * @summary Delete Custom Tool
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomToolApiV1CustomToolsToolIdDelete(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomToolApiV1CustomToolsToolIdDelete(toolId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a custom tool and all its static values and dynamic parameters.  Requires \'custom_tool:write\' permission.
         * @summary Delete Custom Tool
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomToolApiV1CustomToolsToolIdDelete_4(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomToolApiV1CustomToolsToolIdDelete_4(toolId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a dynamic parameter from a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Delete Dynamic Parameter
         * @param {string} toolId 
         * @param {string} paramId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete(toolId: string, paramId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete(toolId, paramId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a dynamic parameter from a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Delete Dynamic Parameter
         * @param {string} toolId 
         * @param {string} paramId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete_5(toolId: string, paramId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete_5(toolId, paramId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a static value from a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Delete Static Value
         * @param {string} toolId 
         * @param {string} valueId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete(toolId: string, valueId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete(toolId, valueId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a static value from a custom tool.  Requires \'custom_tool:write\' permission.
         * @summary Delete Static Value
         * @param {string} toolId 
         * @param {string} valueId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete_6(toolId: string, valueId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete_6(toolId, valueId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific custom tool by ID.  Requires \'custom_tool:view\' permission.
         * @summary Get Custom Tool
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomToolApiV1CustomToolsToolIdGet(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CustomToolResponseDTO> {
            return localVarFp.getCustomToolApiV1CustomToolsToolIdGet(toolId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific custom tool by ID.  Requires \'custom_tool:view\' permission.
         * @summary Get Custom Tool
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomToolApiV1CustomToolsToolIdGet_7(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CustomToolResponseDTO> {
            return localVarFp.getCustomToolApiV1CustomToolsToolIdGet_7(toolId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all custom tools in the current user\'s organization.  Requires \'custom_tool:view\' permission.
         * @summary List Custom Tools
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomToolsApiV1CustomToolsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageCustomToolResponseDTO> {
            return localVarFp.listCustomToolsApiV1CustomToolsGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all custom tools in the current user\'s organization.  Requires \'custom_tool:view\' permission.
         * @summary List Custom Tools
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomToolsApiV1CustomToolsGet_8(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageCustomToolResponseDTO> {
            return localVarFp.listCustomToolsApiV1CustomToolsGet_8(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all dynamic parameters for a custom tool.  Requires \'custom_tool:view\' permission.
         * @summary List Dynamic Parameters
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DynamicParameterResponseDTO>> {
            return localVarFp.listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet(toolId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all dynamic parameters for a custom tool.  Requires \'custom_tool:view\' permission.
         * @summary List Dynamic Parameters
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet_9(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DynamicParameterResponseDTO>> {
            return localVarFp.listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet_9(toolId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all static values for a custom tool.  Requires \'custom_tool:view\' permission.
         * @summary List Static Values
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStaticValuesApiV1CustomToolsToolIdStaticValuesGet(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StaticValueResponseDTO>> {
            return localVarFp.listStaticValuesApiV1CustomToolsToolIdStaticValuesGet(toolId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all static values for a custom tool.  Requires \'custom_tool:view\' permission.
         * @summary List Static Values
         * @param {string} toolId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStaticValuesApiV1CustomToolsToolIdStaticValuesGet_10(toolId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StaticValueResponseDTO>> {
            return localVarFp.listStaticValuesApiV1CustomToolsToolIdStaticValuesGet_10(toolId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Test execute a custom tool with provided dynamic parameters.  This endpoint allows testing a custom tool\'s HTTP request configuration before using it in agent conversations. It performs the full execution flow including: - Validating dynamic parameters - Checking rate limits - Interpolating variables - Making the HTTP request  Requires \'custom_tool:write\' permission.
         * @summary Test Custom Tool
         * @param {string} toolId 
         * @param {TestExecutionRequestDTO} testExecutionRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCustomToolApiV1CustomToolsToolIdTestPost(toolId: string, testExecutionRequestDTO: TestExecutionRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TestExecutionResponseDTO> {
            return localVarFp.testCustomToolApiV1CustomToolsToolIdTestPost(toolId, testExecutionRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Test execute a custom tool with provided dynamic parameters.  This endpoint allows testing a custom tool\'s HTTP request configuration before using it in agent conversations. It performs the full execution flow including: - Validating dynamic parameters - Checking rate limits - Interpolating variables - Making the HTTP request  Requires \'custom_tool:write\' permission.
         * @summary Test Custom Tool
         * @param {string} toolId 
         * @param {TestExecutionRequestDTO} testExecutionRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCustomToolApiV1CustomToolsToolIdTestPost_11(toolId: string, testExecutionRequestDTO: TestExecutionRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TestExecutionResponseDTO> {
            return localVarFp.testCustomToolApiV1CustomToolsToolIdTestPost_11(toolId, testExecutionRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a custom tool\'s configuration.  Requires \'custom_tool:write\' permission.
         * @summary Update Custom Tool
         * @param {string} toolId 
         * @param {CustomToolUpdateDTO} customToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomToolApiV1CustomToolsToolIdPatch(toolId: string, customToolUpdateDTO: CustomToolUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CustomToolResponseDTO> {
            return localVarFp.updateCustomToolApiV1CustomToolsToolIdPatch(toolId, customToolUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a custom tool\'s configuration.  Requires \'custom_tool:write\' permission.
         * @summary Update Custom Tool
         * @param {string} toolId 
         * @param {CustomToolUpdateDTO} customToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomToolApiV1CustomToolsToolIdPatch_12(toolId: string, customToolUpdateDTO: CustomToolUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CustomToolResponseDTO> {
            return localVarFp.updateCustomToolApiV1CustomToolsToolIdPatch_12(toolId, customToolUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a dynamic parameter.  Requires \'custom_tool:write\' permission.
         * @summary Update Dynamic Parameter
         * @param {string} toolId 
         * @param {string} paramId 
         * @param {DynamicParameterUpdateDTO} dynamicParameterUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch(toolId: string, paramId: string, dynamicParameterUpdateDTO: DynamicParameterUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<DynamicParameterResponseDTO> {
            return localVarFp.updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch(toolId, paramId, dynamicParameterUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a dynamic parameter.  Requires \'custom_tool:write\' permission.
         * @summary Update Dynamic Parameter
         * @param {string} toolId 
         * @param {string} paramId 
         * @param {DynamicParameterUpdateDTO} dynamicParameterUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch_13(toolId: string, paramId: string, dynamicParameterUpdateDTO: DynamicParameterUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<DynamicParameterResponseDTO> {
            return localVarFp.updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch_13(toolId, paramId, dynamicParameterUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a static value.  Requires \'custom_tool:write\' permission.
         * @summary Update Static Value
         * @param {string} toolId 
         * @param {string} valueId 
         * @param {StaticValueUpdateDTO} staticValueUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch(toolId: string, valueId: string, staticValueUpdateDTO: StaticValueUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<StaticValueResponseDTO> {
            return localVarFp.updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch(toolId, valueId, staticValueUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a static value.  Requires \'custom_tool:write\' permission.
         * @summary Update Static Value
         * @param {string} toolId 
         * @param {string} valueId 
         * @param {StaticValueUpdateDTO} staticValueUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch_14(toolId: string, valueId: string, staticValueUpdateDTO: StaticValueUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<StaticValueResponseDTO> {
            return localVarFp.updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch_14(toolId, valueId, staticValueUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomToolsApi - object-oriented interface
 * @export
 * @class CustomToolsApi
 * @extends {BaseAPI}
 */
export class CustomToolsApi extends BaseAPI {
    /**
     * Create a new custom tool in the current organization.  Requires \'custom_tool:write\' permission.
     * @summary Create Custom Tool
     * @param {CustomToolCreateDTO} customToolCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public createCustomToolApiV1CustomToolsPost(customToolCreateDTO: CustomToolCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).createCustomToolApiV1CustomToolsPost(customToolCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new custom tool in the current organization.  Requires \'custom_tool:write\' permission.
     * @summary Create Custom Tool
     * @param {CustomToolCreateDTO} customToolCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public createCustomToolApiV1CustomToolsPost_1(customToolCreateDTO: CustomToolCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).createCustomToolApiV1CustomToolsPost_1(customToolCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new dynamic parameter for a custom tool.  Requires \'custom_tool:write\' permission.
     * @summary Create Dynamic Parameter
     * @param {string} toolId 
     * @param {DynamicParameterCreateDTO} dynamicParameterCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost(toolId: string, dynamicParameterCreateDTO: DynamicParameterCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost(toolId, dynamicParameterCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new dynamic parameter for a custom tool.  Requires \'custom_tool:write\' permission.
     * @summary Create Dynamic Parameter
     * @param {string} toolId 
     * @param {DynamicParameterCreateDTO} dynamicParameterCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost_2(toolId: string, dynamicParameterCreateDTO: DynamicParameterCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).createDynamicParameterApiV1CustomToolsToolIdDynamicParametersPost_2(toolId, dynamicParameterCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new static value for a custom tool.  Requires \'custom_tool:write\' permission.
     * @summary Create Static Value
     * @param {string} toolId 
     * @param {StaticValueCreateDTO} staticValueCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public createStaticValueApiV1CustomToolsToolIdStaticValuesPost(toolId: string, staticValueCreateDTO: StaticValueCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).createStaticValueApiV1CustomToolsToolIdStaticValuesPost(toolId, staticValueCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new static value for a custom tool.  Requires \'custom_tool:write\' permission.
     * @summary Create Static Value
     * @param {string} toolId 
     * @param {StaticValueCreateDTO} staticValueCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public createStaticValueApiV1CustomToolsToolIdStaticValuesPost_3(toolId: string, staticValueCreateDTO: StaticValueCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).createStaticValueApiV1CustomToolsToolIdStaticValuesPost_3(toolId, staticValueCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a custom tool and all its static values and dynamic parameters.  Requires \'custom_tool:write\' permission.
     * @summary Delete Custom Tool
     * @param {string} toolId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public deleteCustomToolApiV1CustomToolsToolIdDelete(toolId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).deleteCustomToolApiV1CustomToolsToolIdDelete(toolId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a custom tool and all its static values and dynamic parameters.  Requires \'custom_tool:write\' permission.
     * @summary Delete Custom Tool
     * @param {string} toolId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public deleteCustomToolApiV1CustomToolsToolIdDelete_4(toolId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).deleteCustomToolApiV1CustomToolsToolIdDelete_4(toolId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a dynamic parameter from a custom tool.  Requires \'custom_tool:write\' permission.
     * @summary Delete Dynamic Parameter
     * @param {string} toolId 
     * @param {string} paramId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete(toolId: string, paramId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete(toolId, paramId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a dynamic parameter from a custom tool.  Requires \'custom_tool:write\' permission.
     * @summary Delete Dynamic Parameter
     * @param {string} toolId 
     * @param {string} paramId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete_5(toolId: string, paramId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).deleteDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdDelete_5(toolId, paramId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a static value from a custom tool.  Requires \'custom_tool:write\' permission.
     * @summary Delete Static Value
     * @param {string} toolId 
     * @param {string} valueId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete(toolId: string, valueId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete(toolId, valueId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a static value from a custom tool.  Requires \'custom_tool:write\' permission.
     * @summary Delete Static Value
     * @param {string} toolId 
     * @param {string} valueId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete_6(toolId: string, valueId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).deleteStaticValueApiV1CustomToolsToolIdStaticValuesValueIdDelete_6(toolId, valueId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific custom tool by ID.  Requires \'custom_tool:view\' permission.
     * @summary Get Custom Tool
     * @param {string} toolId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public getCustomToolApiV1CustomToolsToolIdGet(toolId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).getCustomToolApiV1CustomToolsToolIdGet(toolId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific custom tool by ID.  Requires \'custom_tool:view\' permission.
     * @summary Get Custom Tool
     * @param {string} toolId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public getCustomToolApiV1CustomToolsToolIdGet_7(toolId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).getCustomToolApiV1CustomToolsToolIdGet_7(toolId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all custom tools in the current user\'s organization.  Requires \'custom_tool:view\' permission.
     * @summary List Custom Tools
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public listCustomToolsApiV1CustomToolsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).listCustomToolsApiV1CustomToolsGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all custom tools in the current user\'s organization.  Requires \'custom_tool:view\' permission.
     * @summary List Custom Tools
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public listCustomToolsApiV1CustomToolsGet_8(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).listCustomToolsApiV1CustomToolsGet_8(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all dynamic parameters for a custom tool.  Requires \'custom_tool:view\' permission.
     * @summary List Dynamic Parameters
     * @param {string} toolId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet(toolId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet(toolId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all dynamic parameters for a custom tool.  Requires \'custom_tool:view\' permission.
     * @summary List Dynamic Parameters
     * @param {string} toolId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet_9(toolId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).listDynamicParametersApiV1CustomToolsToolIdDynamicParametersGet_9(toolId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all static values for a custom tool.  Requires \'custom_tool:view\' permission.
     * @summary List Static Values
     * @param {string} toolId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public listStaticValuesApiV1CustomToolsToolIdStaticValuesGet(toolId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).listStaticValuesApiV1CustomToolsToolIdStaticValuesGet(toolId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all static values for a custom tool.  Requires \'custom_tool:view\' permission.
     * @summary List Static Values
     * @param {string} toolId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public listStaticValuesApiV1CustomToolsToolIdStaticValuesGet_10(toolId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).listStaticValuesApiV1CustomToolsToolIdStaticValuesGet_10(toolId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Test execute a custom tool with provided dynamic parameters.  This endpoint allows testing a custom tool\'s HTTP request configuration before using it in agent conversations. It performs the full execution flow including: - Validating dynamic parameters - Checking rate limits - Interpolating variables - Making the HTTP request  Requires \'custom_tool:write\' permission.
     * @summary Test Custom Tool
     * @param {string} toolId 
     * @param {TestExecutionRequestDTO} testExecutionRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public testCustomToolApiV1CustomToolsToolIdTestPost(toolId: string, testExecutionRequestDTO: TestExecutionRequestDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).testCustomToolApiV1CustomToolsToolIdTestPost(toolId, testExecutionRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Test execute a custom tool with provided dynamic parameters.  This endpoint allows testing a custom tool\'s HTTP request configuration before using it in agent conversations. It performs the full execution flow including: - Validating dynamic parameters - Checking rate limits - Interpolating variables - Making the HTTP request  Requires \'custom_tool:write\' permission.
     * @summary Test Custom Tool
     * @param {string} toolId 
     * @param {TestExecutionRequestDTO} testExecutionRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public testCustomToolApiV1CustomToolsToolIdTestPost_11(toolId: string, testExecutionRequestDTO: TestExecutionRequestDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).testCustomToolApiV1CustomToolsToolIdTestPost_11(toolId, testExecutionRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a custom tool\'s configuration.  Requires \'custom_tool:write\' permission.
     * @summary Update Custom Tool
     * @param {string} toolId 
     * @param {CustomToolUpdateDTO} customToolUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public updateCustomToolApiV1CustomToolsToolIdPatch(toolId: string, customToolUpdateDTO: CustomToolUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).updateCustomToolApiV1CustomToolsToolIdPatch(toolId, customToolUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a custom tool\'s configuration.  Requires \'custom_tool:write\' permission.
     * @summary Update Custom Tool
     * @param {string} toolId 
     * @param {CustomToolUpdateDTO} customToolUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public updateCustomToolApiV1CustomToolsToolIdPatch_12(toolId: string, customToolUpdateDTO: CustomToolUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).updateCustomToolApiV1CustomToolsToolIdPatch_12(toolId, customToolUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a dynamic parameter.  Requires \'custom_tool:write\' permission.
     * @summary Update Dynamic Parameter
     * @param {string} toolId 
     * @param {string} paramId 
     * @param {DynamicParameterUpdateDTO} dynamicParameterUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch(toolId: string, paramId: string, dynamicParameterUpdateDTO: DynamicParameterUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch(toolId, paramId, dynamicParameterUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a dynamic parameter.  Requires \'custom_tool:write\' permission.
     * @summary Update Dynamic Parameter
     * @param {string} toolId 
     * @param {string} paramId 
     * @param {DynamicParameterUpdateDTO} dynamicParameterUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch_13(toolId: string, paramId: string, dynamicParameterUpdateDTO: DynamicParameterUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).updateDynamicParameterApiV1CustomToolsToolIdDynamicParametersParamIdPatch_13(toolId, paramId, dynamicParameterUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a static value.  Requires \'custom_tool:write\' permission.
     * @summary Update Static Value
     * @param {string} toolId 
     * @param {string} valueId 
     * @param {StaticValueUpdateDTO} staticValueUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch(toolId: string, valueId: string, staticValueUpdateDTO: StaticValueUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch(toolId, valueId, staticValueUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a static value.  Requires \'custom_tool:write\' permission.
     * @summary Update Static Value
     * @param {string} toolId 
     * @param {string} valueId 
     * @param {StaticValueUpdateDTO} staticValueUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomToolsApi
     */
    public updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch_14(toolId: string, valueId: string, staticValueUpdateDTO: StaticValueUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).updateStaticValueApiV1CustomToolsToolIdStaticValuesValueIdPatch_14(toolId, valueId, staticValueUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

